class CommissionsPermissions {
    constructor({ show = false, update = false } = {}) {
        this.show = show
        this.update = update
    }
}

export default CommissionsPermissions
